export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mobile-menu.vue?vue&type=template&id=47f71693"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/mobile-menu/mobile-menu.vue?vue&type=template&id=47f71693
// module id = Apn7
// module chunks = 0